import api from '~/services/api';
import { type JSONAPIMessage } from '~/types/APIMessage';
import { type BaseAddress } from '~/types/Address';
import { type JSONShipmentExtras } from '~/types/OrderBatchEntry';
import { type JSONRate } from '~/types/Rate';
import { type JSONShipment } from '~/types/Shipment';

type QuoteParcel = {
  distance_unit: string;
  height?: string;
  length?: string;
  mass_unit: string;
  template?: string;
  weight: string;
  width?: string;
};

type CreateShipmentPayload = {
  address_from: BaseAddress;
  address_return?: BaseAddress;
  address_to: BaseAddress;
  async: false;
  carrier_accounts?: string[];
  extra?: Partial<JSONShipmentExtras>;
  object_purpose: `QUOTE`;
  parcels: QuoteParcel[];
  shipment_date: string;
};

type JSONShipmentQuote = {
  messages: JSONAPIMessage[];
  rates: JSONRate[];
};

const getRates = (shipmentId: string) =>
  api.request<JSONShipment>({
    method: 'GET',
    url: `/shipments/${shipmentId}`,
  });

const createShipment = ({
  address_from,
  address_return,
  address_to,
  ...payload
}: CreateShipmentPayload) =>
  api.request<JSONShipmentQuote>({
    data: {
      ...payload,
      address_from: { ...address_from, country: address_from.country?.iso2 },
      ...(address_return && {
        address_return: { ...address_return, country: address_return.country?.iso2 },
      }),
      address_to: { ...address_to, country: address_to.country?.iso2 },
    },
    method: 'POST',
    url: '/shipments/',
  });

export { createShipment, getRates, type CreateShipmentPayload };
